import React, { Component } from "react";
import { Card, CardBody, Icon } from "design-react-kit";

export default class RevisorDetailAccount extends Component {
  render() {
    if (!this.props.data) return false;

    const { user, profile } = this.props.data;
    const { name, surname, email } = user;
    const { phone, mobile } = profile;

    return (
      <>
        <Card
          tag="div"
          className="card-bg card-big rounded border-bottom-card mb-4"
        >
          <div className="flag-icon" />
          <div className="etichetta">
            <Icon icon="it-user" padding={false} />
            <span>Account</span>
          </div>
          <CardBody>
            <div>
              <b>Nome:</b> {name}
            </div>
            <div>
              <b>Cognome:</b> {surname}
            </div>
            <div>
              <b>Email:</b> {email}
            </div>
            <div>
              <b>Telefono:</b> {phone}
            </div>
            <div>
              <b>Cellulare:</b> {mobile}
            </div>
          </CardBody>
        </Card>
      </>
    );
  }
}
